<template>
  <div class="step-1">
    <transition name="component-fade" mode="out-in">
      <div v-if="id && name">
        <section class="background-gradient mb-3 py-2 mb-sm-5 py-sm-5">
          <div class="container">
            <div class="col-sm-9 mx-auto text-center mb-5 pb-sm-5">
              <img :src="logoUrl" class="mw-100" alt="" />
              <ProgressBar progress="75" label="3 / 4" />
            </div>

            <h2 v-html="textWaitCustomer"></h2>
            <h3 class="mt-3">{{ textAddThis }} {{ textwillShip }}</h3>
            <div class="people mt-2">
              <img :src="$root.cdn_url + '/assets/images/upsells/zoom-icon.svg'" alt="" />
              <span :class="{ opacityTransition: showPeopleOnline }">{{ peopleViewing }}</span>
              {{ $t("checkout.users_online") }}
            </div>
          </div>

          <div class="container container--lg mt-sm-5">
            <div class="row">
              <div class="d-sm-none text-center w-100">
                <h1>{{ name }}</h1>
                <small>(757)</small>
                <div class="review-5star d-inline-block ml-2 mb-2" :style="{ width: 5 * 20 + 'px' }">
                  <img :src="$root.cdn_url + '/assets/images/zmc10/5star.svg'" />
                </div>
              </div>

              <div v-html="getProductImageHtml()" class="col-sm-5 pb-3 pb-sm-0"></div>

              <div class="col-sm-7">
                <div class="d-sm-block d-none">
                  <h1>{{ name }}</h1>
                  <small>(757)</small>
                  <div class="review-5star d-inline-block ml-2" :style="{ width: 5 * 20 + 'px' }">
                    <img :src="$root.cdn_url + '/assets/images/zmc10/5star.svg'" />
                  </div>
                </div>

                <div class="description mt-3">
                  <p v-html="splashDescription"></p>
                </div>

                <div class="description">
                  <p v-html="isVirtual ? $t('upsells.act_fast_virtual') : $t('upsells.act_fast')"></p>
                  <p>
                    <!-- <s>{{ $t("upsells.regular_price") }}: </s> -->
                    <b class="red">{{ $t("upsells.today_price") }} {{ priceFormatted }} {{ isVirtual ? "" : "(+" + $t("upsells.free_shipping") + ")" }}</b>
                  </p>
                </div>

                <div class="row">
                  <div class="col-sm-10">
                    <AmountSelector :list="selectList" :prices="upsellPrices" v-model="quantity" v-if="!isVirtual" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6 mx-auto">
              <div @click="add(quantity)" class="red-button mt-4">
                <div class="d-flex">
                  <img :src="$root.cdn_url + '/assets/images/upsells/cart.svg'" class="mr-2" alt="" />
                  <div>{{ textAdd }}</div>
                </div>
              </div>

              <div class="mt-4 text-center">
                <img :src="$root.cdn_url + '/assets/images/zmc10/partners.png'" style="max-width: 396px;" class="w-100" alt="" />
              </div>

              <p class="no">
                <a @click="$emit('skip')">
                  {{ $t("upsells.cancel.full") }}
                </a>
              </p>
            </div>
          </div>
        </section>
        <section>
          <div class="container container--lg">
            <h2>{{ $t("upsells.1000_plus") }}</h2>
            <div class="row mb-5">
              <div v-for="(review, id) of reviews" :key="'review' + id" class="col-sm-6">
                <div class="review d-flex mt-3 mx-sm-2">
                  <div>
                    <div class="review__avatar">
                      <img :src="review.image" alt="" />
                    </div>
                    <div class="review-5star text-center" :style="{ width: review.rate * 20 + 'px' }">
                      <img :src="$root.cdn_url + '/assets/images/zmc10/5star.svg'" />
                    </div>
                  </div>
                  <div class="pl-3 w-100">
                    <div class="review__header d-flex justify-content-between">
                      <div class="review__verified">
                        <img class="mr-2" :src="$root.cdn_url + '/assets/images/zmc10/check.svg'" />
                        {{ $t("reviews.verified") }}
                      </div>
                      <div class="text-align-right">
                        {{ review.name }}
                      </div>
                    </div>
                    <div class="mt-2 review__text" v-html="review.text"></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-sm-6 mx-auto">
              <AmountSelector :list="selectList" :prices="upsellPrices" v-model="quantity" v-if="!isVirtual" />

              <div @click="add(quantity)" class="red-button mt-4">
                <div class="d-flex">
                  <img :src="$root.cdn_url + '/assets/images/upsells/cart.svg'" class="mr-2" alt="" />
                  <div>{{ textAdd }}</div>
                </div>
              </div>

              <div class="mt-4 text-center">
                <img :src="$root.cdn_url + '/assets/images/zmc10/partners.png'" style="max-width: 396px;" class="w-100" alt="" />
              </div>

              <p class="no">
                <a @click="$emit('skip')">
                  {{ $t("upsells.cancel.full") }}
                </a>
              </p>
            </div>
          </div>
        </section>
      </div>
      <div v-else class="text-center m-5">
        <Spinner />
      </div>
    </transition>
  </div>
</template>

<script>
import { t } from "../../utils/i18n";
import upsells from "../../mixins/upsells";
import { getUppSells } from "../../services/upsells";
import Spinner from "../common/preloaders/Spinner";
import ProgressBar from "./ProgressBar";
import AmountSelector from "./AmountSelector";

export default {
  name: "Step1",
  mixins: [upsells],
  props: ["id", "discount", "accessoryStep"],
  components: { Spinner, ProgressBar, AmountSelector },

  data() {
    return {
      description: null,
      splashDescription: null,
      upsellPrices: {},
      name: "",
      productName: null,
      price: 0,
      priceFormatted: "",
      finalPrice: null,
      finalPricePure: null,
      imageUrl: null,
      gifImageUrl: null,
      vimeoId: null,
      videoFile: null,
      isVirtual: false,
      isLoading: false,
      quantity: 1,
      peopleViewing: 100, // random interactive number
      showPeopleOnline: true
    };
  },

  watch: {
    id: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.name = null;
          this.isLoading = true;
          getUppSells(newVal, this.getAllowedUpsellQty() || 1, this.accessoryStep)
            .then(res => {
              if (res && res.data) {
                this.upsellPrices = res.data.upsell.upsellPrices;
                this.name = res.data.upsell.long_name;
                this.productName = res.data.upsell.product_name;
                this.reviews = res.data.upsell.reviews ? res.data.upsell.reviews.slice(0, 4) : [];

                this.description = res.data.upsell.upsell_plusone_text ? res.data.upsell.upsell_plusone_text : res.data.upsell.description;
                this.splashDescription = res.data.upsell.splash_description;

                this.imageUrl = res.data.upsell.image;
                this.gifImageUrl = res.data.upsell.gif_image;
                this.vimeoId = res.data.upsell.vimeo_id;
                this.videoFile = res.data.upsell.video_file;
                this.priceFormatted = (this.upsellPrices["1"] && this.upsellPrices["1"].price_text) || "";
                this.price = (this.upsellPrices["1"] && this.upsellPrices["1"].price) || 0;
                this.finalPrice = (this.upsellPrices["1"] && this.upsellPrices["1"].price_text) || "";
                this.finalPricePure = (this.upsellPrices["1"] && this.upsellPrices["1"].price) || 0;
                this.isVirtual = res.data.upsell.type === 'virtual';
              }
            })
            .then(() => {
              this.isLoading = false;
            });
        }
      }
    }
  },

  computed: {
    textWaitCustomer() {
      return this.$t("upsells.wait_customer_2", { NAME: js_data.order_customer.customer_first_name || localStorage.getItem("stripe_username") || "" });
    },
    textAddThis() {
      return this.$t("upsells.add_this", { DISCOUNT: this.upsellPrices.discount_percent + "%" });
    },
    textwillShip() {
      return this.$t(this.isVirtual ? "upsells.we_will_ship_virtual" : "upsells.we_will_ship");
    },
    textAdd() {
      return this.$t("upsells.yes_add", { PRODUCT: this.name });
    },

    selectList() {
      const data = Object.keys(this.upsellPrices)
        .filter(key => parseInt(key) > 0 && parseInt(key) <= this.getAllowedUpsellQty())
        .map(key => {
          return {
            label: `${key}x ${this.name} - ${this.upsellPrices[key].price_text}`,
            text: `${key}x ${this.name} - ${this.upsellPrices[key].price_text}`,
            value: key
          };
        });

      return data;
    }
  },

  methods: {
    add(quantity) {
      quantity = +quantity;

      this.finalPrice = (this.upsellPrices && this.upsellPrices[quantity] && this.upsellPrices[quantity].price_text) || "";
      this.finalPricePure = (this.upsellPrices && this.upsellPrices[quantity] && this.upsellPrices[quantity].price) || 0;

      this.addToCart(quantity);
    },

    generatePeopleCount() {
      return Math.floor(Math.random() * 50 + 50);
    }
  },

  created() {
    this.peopleViewing = this.generatePeopleCount();
    this.logoUrl = js_data.product.logo_image;

    setInterval(() => {
      this.showPeopleOnline = false;
      // toggle animation class with delay to make animation
      setTimeout(() => {
        this.peopleViewing = this.generatePeopleCount();
        this.showPeopleOnline = true;
      }, 100);
    }, 7000);
  }
};
</script>

<style lang="scss">
.step-1 {
  h1 {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    color: #0a0f0a;
  }

  h2 {
    font-weight: bold;
    font-size: 24px;
    line-height: 27px;
    text-align: center;
    color: #333333;
    span {
      color: red;
    }
  }

  h3 {
    font-weight: normal;
    font-size: 20px;
    line-height: 27px;
    text-align: center;
    color: #333333;
  }

  .select-standart {
    background: #ffffff;
    border: 1px solid #d9d9d9;
    box-sizing: border-box;
    border-radius: 5px;
    font-size: 18px;
    line-height: 24px;
    color: #878787;
    padding: 13px 21px;
    height: auto;
  }

  .people {
    font-size: 18px;
    line-height: 21px;
    color: #ff0000;
    text-align: center;

    span {
      opacity: 0;
    }

    .opacityTransition {
      opacity: 1 !important;
      transition: all 1s;
    }
  }

  .description {
    p {
      font-size: 20px;
      line-height: 23px;
      color: #333333;
      padding: 8px 0;

      .red {
        font-size: 20px;
        line-height: 23px;
        color: red;
      }
    }
  }

  .review {
    flex-direction: row;
    padding: 0;
    border-top: 0;
    font-family: Roboto, Arial, Helvetica, sans-serif;

    &__header {
      font-size: 14px;
    }

    &__avatar {
      overflow: hidden;

      & > img {
        width: 93px;
        border-radius: 50%;
        padding: 3px;
        border: 1px solid rgb(181, 181, 181);
      }
    }

    &__verified {
      color: #4bad00;
    }

    &__text {
      font-size: 16px;
    }
  }

  @media screen and (max-width: 767px) {
    h1 {
      font-size: 21px;
      line-height: 30px;
    }
  }
}
</style>
